import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { resolveSingleModeFooterErrorMessage } from '@/libraries/betSlip/singleModeBetSlipErrorMessage';
import { useBetSlipCtaPresentation } from '@/libraries/composables/useBetSlipCtaPresentation';
import { useAccountStore } from '@/stores/accountStore';
import { useSingleModeBetSlipStore } from '@/stores/betSlip/singleModeBetSlipStore';

export function useSingleModeBetSlipCta() {
    const store = useSingleModeBetSlipStore();
    const {
        ctaAction,
        ctaTicketCount,
        placeBetFooterError,
        balanceError,
        invalidStakeTickets,
        unacceptedOddsChangeTickets,
        isCtaDisabled,
    } = storeToRefs(store);
    const { handleSingleCtaClick } = store;
    const { customerInfo } = storeToRefs(useAccountStore());

    const footerErrorMessage = computed(() => resolveSingleModeFooterErrorMessage({
        placeBetError: placeBetFooterError.value,
        balanceError: balanceError.value,
        invalidStakeTicketCount: invalidStakeTickets.value.length,
        ctaAction: ctaAction.value,
        unacceptedOddsChangeTicketCount: unacceptedOddsChangeTickets.value.length,
        playerType: customerInfo.value.playerType,
    }));
    const {
        renderedCtaAction,
        isRenderedCtaDisabled,
        handleRenderedCtaClick,
    } = useBetSlipCtaPresentation({
        ctaAction,
        isCtaDisabled,
        handleCtaClick: handleSingleCtaClick,
    });

    return {
        footerErrorMessage,
        ctaTicketCount,
        renderedCtaAction,
        isRenderedCtaDisabled,
        handleRenderedCtaClick,
    };
}
